import * as CONSTANTS from '../../constants';

export default {
    /**
     * Toggle the minimized.
     *
     * @param state
     */
    [CONSTANTS.NAV_MINIMIZE_TOGGLE] (state) {
        state.minimized = !state.minimized;
    },

    /**
     * Set the minimized status.
     *
     * @param state
     * @param status
     */
    [CONSTANTS.NAV_MINIMIZE_SET] (state, status) {
        state.minimized = status;
    },

    /**
     * Toggle the navbar top menu.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.NAV_MENU_TOGGLE] (state, payload) {
        // If payload set open to payload to be able for force close
        if (payload !== undefined) {
            state.menu.open = payload;
        } else {
            state.menu.open = !state.menu.open;
        }
    },

    /**
     * Set the language for the application.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.LANGUAGE_SELECT] (state, payload) {
        state.language = payload;
    },

    /**
     * Set the valid languages from the JSON files.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.LANGUAGE_SET] (state, payload) {
        state.languages = payload;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/nav/mutations.js